export default __webpack_public_path__ + "static/media/slider1.5b23b8d5.jpg";